<template>
  <div class="d-contents">
    <div v-for="tax in taxes" :key="tax.id" class="offers-table-cell_tax-wrapper">
      <div class="offers-table-cell_tax">
        <div class="text spacex-4 fs-14 fw-5">
          <span v-if="currencySymbol" class="text text-grey fs-14">{{ currencySymbol }}</span>
          <span v-if="tax.total">{{ addSpaces(tax.total) }}</span>
        </div>
        <div class="text text-grey fs-14 fw-5">{{ tax.name }} ({{ tax.percent_total }}%)</div>
      </div>
    </div>
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';

  export default {
    name: 'TenderTaxes',
    props: {
      taxes: {
        type: Array,
        required: true,
      },
      currencySymbol: {
        type: String,
        required: true,
      },
    },
    methods: {
      addSpaces,
    },
  };
</script>
